import { Article, Category, Integrates3rdPartyType } from 'interfaces/types'
export type FontSize = 'small' | 'medium' | 'large'

export enum ChineseTranslateEnum {
  traditional,
  simplified,
}

export type ArticleStoreValueType = {
  articles: Array<Article>
  bookmarkIds: Array<string | number>
  chineseTranslate: ChineseTranslateEnum
  currentArticle?: Article | null
  currentProgress: number
  fontSize: FontSize
  isBookmarked: boolean
  isCommentPopupOpen: boolean
  isLiked: boolean
  isDisliked: boolean
  totalComment: number | null
  categories: Array<Category>
  thirdParty: Integrates3rdPartyType | null
  showDictionaryShortcutBtn: boolean
  inFirstViewport: boolean
}
export type ArticleStoreActionType = {
  addToArticles: (data: Article) => void
  addToBookmark: (data: string | number) => void
  removeBookmark: (data: string | number) => void
  setArticles: (
    data: Array<Article> | ((a: Array<Article>) => Array<Article>),
  ) => void
  setBookmarkIds: (data: Array<string | number>) => void
  setChineseTranslate: (data: ChineseTranslateEnum) => void
  setCurrentArticle: (data: Article | null) => void
  setCurrentProgress: (data: number) => void
  cycleFontSize: () => void
  setIsBookmarked: (data: boolean) => void
  setIsCommentPopupOpen: (data: boolean) => void
  setIsLiked: (data: boolean) => void
  setIsDisliked: (data: boolean) => void
  setTotalComment: (data: number | null) => void
  setCategories: (data: Array<Category>) => void
  setShowDictionaryShortcutBtn: (data: boolean) => void
  setInFirstViewPort: (data: boolean) => void
}
export type ArticleStoreType = ArticleStoreValueType & ArticleStoreActionType
